import React, { useState } from 'react'
import FormValidator from './FormValidators/FormValidator'
import { Link, useNavigate } from 'react-router-dom'
import Navbar from './Partial/Navbar';
import '../../src/assets/signup.css'

export default function SignUp() {
    let navigate = useNavigate();
    let [data, setData] = useState({
        name: "",
        username: "",
        email: "",
        phone: "",
        password: "",
        cpassword: ""

    })
    let [errorMessage, setErrorMessage] = useState({
        name: "Name is Mendetory",
        username: "Username is Mendetory",
        email: "Email is Mendetory",
        phone: "Phone is Mendetory",
        password: "Password is Mendetory"
    })

    let [show, setShow] = useState(false)

    function getInputData(e) {
        let { name, value } = e.target
        if (name !== "cpassword") {
            setErrorMessage((old) => {
                return {
                    ...old,
                    [name]: FormValidator(e)
                }
            })
        }

        setData((old) => {
            return {
                ...old,
                [name]: value
            }
        })
    }

    async function postData(e) {
        e.preventDefault()
        if (data.cpassword === data.password) {
            let error = Object.values(errorMessage).find((x) => x !== "")
            if (error)
                setShow(true)
            else {

                let item = {
                    name: data.name,
                    username: data.username,
                    email: data.email,
                    phone: data.phone,
                    password: data.password,
                    role: "Buyer"
                }
                let response = await fetch("/api/user", {
                    method: "POST",
                    headers: {
                        "content-type": "application/json"
                    },
                    body: JSON.stringify(item)
                })
                response = await response.json()
                if (response.result === "Done") {
                    localStorage.setItem("login", true)
                    localStorage.setItem("name", response.data.name)
                    localStorage.setItem("userid", response.data._id)
                    localStorage.setItem("role", response.data.role)
                    localStorage.setItem("token", response.token)
                    navigate("/profile")
                }
                else {
                    setShow(true)
                    setErrorMessage((old) => {
                        return {
                            ...old,
                            'username': response.reason?.username ?? "",
                            'email': response.reason?.email ?? "",
                            'password': response.reason?.password ?? "",
                        }
                    })
                }
            }
        }

        else {
            setShow(true)
            setErrorMessage((old) => {
                return {
                    ...old,
                    "password": "password and confirm password is does't matched"
                }
            })
        }
    }
    return (
        <>
            <Navbar />
            <div className="d-flex justify-content-center align-items-center background ">
                <div className="card p-2 mt-5 mx-4" style={{ maxWidth: '400px', maxHeight: '70vh', overflowY: 'auto' }}>
                    <div className="card-body">
                        <h2 className="text-center text-dark"><span className="text-info">Mini</span>Store</h2>
                        <h6 className="card-title text-center border-bottom border-2 p-2">Create Your Free Account</h6>
                        <form onSubmit={postData}>
                            <div className="row">
                                <div className="col-12 mt-3">
                                    <label className="text-info">Name</label>
                                    <input type="text" name="name" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.name ? "border-danger" : "border-dark"}`} placeholder="Full Name" />
                                    {show && errorMessage.name ? <p className="text-danger">{errorMessage.name}</p> : ""}
                                </div>
                                <div className="col-12 mt-3">
                                    <label className="text-info">Username</label>
                                    <input type="text" name="username" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.username ? "border-danger" : "border-dark"}`} placeholder="Username" />
                                    {show && errorMessage.username ? <p className="text-danger">{errorMessage.username}</p> : ""}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mt-3">
                                    <label className="text-info">Email</label>
                                    <input type="email" name="email" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.email ? "border-danger" : "border-dark"}`} placeholder="Email Address" />
                                    {show && errorMessage.email ? <p className="text-danger">{errorMessage.email}</p> : ""}
                                </div>
                                <div className="col-12 mt-3">
                                    <label className="text-info">Phone</label>
                                    <input type="text" name="phone" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.phone ? "border-danger" : "border-dark"}`} placeholder="Phone Number" />
                                    {show && errorMessage.phone ? <p className="text-danger">{errorMessage.phone}</p> : ""}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mt-3">
                                    <label className="text-info">Password</label>
                                    <input type="password" name="password" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.password ? "border-danger" : "border-dark"}`} placeholder="Password" />
                                    {show && errorMessage.password ? <p className="text-danger">{errorMessage.password}</p> : ""}
                                </div>
                                <div className="col-12 mt-3">
                                    <label className="text-info">Confirm Password</label>
                                    <input type="password" name="cpassword" onChange={getInputData} className="form-control border-2 border-dark" placeholder="Confirm Password" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <button type="submit" className="btn btn-info w-100">Sign-Up</button>
                            </div>
                            <div className="mt-2">
                                <Link to="/login" className="text-dark" style={{ fontSize: "14px" }}>
                                    Have An Account? <span className="text-info">Log-In</span>
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}
